import Button from "components/common/Button"
import React, { useState } from "react"
import ToggleSwitch from "components/toggle-switch"
import ReactTooltip from "react-tooltip"
const ModuleCover = ({
  title,
  onClick,
  redirectText,
  activeColor,
  ongoingExam,
  moduleContent,
  displayTimer,
  onToggleTheme,
  LMStheme,
}) => {
  const [toggle, setToggle] = useState(false)

  const toggleMenu = (toggle) => {
    var myBody = document.getElementById("root")
    if (toggle) {
      myBody.classList.add("overlay")
    } else {
      myBody.classList.remove("overlay")
    }
    setToggle(toggle)
  }

  const changeSize = (type) => {
    var rootStyle = document.querySelector(":root")
    var currentFontSize = getComputedStyle(rootStyle).getPropertyValue(
      "--font-size"
    )
    if (type === "add" && parseInt(currentFontSize) < 24) {
      rootStyle.style.setProperty(
        "--font-size",
        parseInt(currentFontSize) + 1 + "px"
      )
    } else if (type === "subtract" && parseInt(currentFontSize) > 12) {
      rootStyle.style.setProperty(
        "--font-size",
        parseInt(currentFontSize) - 1 + "px"
      )
    }
  }
  return (
    <>
      <div className="module-cover">
        <div className="module-wrapper">
          {toggle ? (
            <>
              <div className="navbar-close">
                <button
                  id="hamburger-icon"
                  className={toggle ? "active" : ""}
                  onClick={() => toggleMenu(!toggle)}
                >
                  <span aria-hidden="true" className="line line-1"></span>
                  <span aria-hidden="true" className="line line-2"></span>
                  <span aria-hidden="true" className="line line-3"></span>
                </button>
              </div>
              <div className="mobile-wrapper">{moduleContent}</div>
            </>
          ) : (
            <div className="navbar-close">
              <button
                id="hamburger-icon"
                className={toggle ? "active" : ""}
                onClick={() => toggleMenu(!toggle)}
              >
                <span aria-hidden="true" className="line line-1"></span>
                <span aria-hidden="true" className="line line-2"></span>
                <span aria-hidden="true" className="line line-3"></span>
              </button>
            </div>
          )}
          <ToggleSwitch
            id="darkmode"
            optionLabels={["Dark", "Light"]}
            onChange={onToggleTheme}
            checked={LMStheme}
          />
          <div className="font-sizer">
            <ReactTooltip effect="solid" id="decrease" place="bottom" />
            <Button
              data-tip="Decrease font size"
              data-for="decrease"
              outlined
              label="-"
              onClick={() => changeSize("subtract")}
            />

            <ReactTooltip effect="solid" id="add" place="bottom" />
            <Button
              data-tip="Increase font size"
              data-for="add"
              outlined
              label="+"
              onClick={() => changeSize("add")}
            />
          </div>
          <h3 className="title">{title}</h3>
          {ongoingExam && displayTimer ? (
            <div className="course-timer">
              <div className="timer-details">
                <p className="title" style={{ color: activeColor }}>
                  Course Remaining Time
                </p>
                <p className="note">
                  Timer will continue to run when you leave this page
                </p>
              </div>
              <p className="timer-countdown">{displayTimer}</p>
            </div>
          ) : null}
          <Button outlined label={redirectText} onClick={onClick} />
        </div>
      </div>
    </>
  )
}

export default ModuleCover
